import { createContext, useContext } from 'react';

/** В какой теме рисовать всплывающее (меню, «Удалить?»): приложения или тёмной — над тёмной колонкой */
export type PopupTheme = 'app' | 'dark';

/**
 * Ставит тёмная карточка (Card dark): её портал — вне колонки, в теме приложения, поэтому тёмную тему всплывающее
 * получает отсюда — меню над чёрной панелью тоже тёмное.
 */
export const PopupThemeContext = createContext<PopupTheme>('app');

/** Класс темы для всплывающего в текущем месте: dark — токены тёмной темы раздела внутри всплывающего */
export function usePopupThemeClass(): string {
  return useContext(PopupThemeContext) === 'dark' ? 'dark' : '';
}
